<template>
  <div class="move-in-company">
    <div class="move-in-company__filters">
      <c-input
        ref="moveInCompanyPeriod"
        v-model="periodLocal"
        class="move-in-company__filters__period"
        label="За период"
        placeholder="00.00.0000 - 00.00.0000"
        type="period"
        icon="calendar"
        :clearable="true"
        :icon-right="true"
      />
      <div class="move-in-company__filters__block">
        <c-button
          class="move-in-company__filters__block__button"
          label="Применить"
          color="primary"
          @click="applyFilters"
        />
        <c-switcher
          v-model="isGroupedTable"
          class="move-in-company__filters__block__switcher"
          label="Группировать по должностям"
        />
      </div>
    </div>

    <div class="move-in-company__table">
      <c-data-table-personal-employee
        v-if="!isTableLoading"
        id="moveInCompany"
        ref="table"
        :sorted-column="tableData.sortedColumn"
        :levels="1"
        empty-records-label="Записи не найдены"
        :disabled-columns="[]"
        :data="tableData"
        @sortedEvent="refreshTable"
      />
      <c-loader
        v-if="isTableLoading"
        class="move-in-company__table__loader"
        label="Данные загружаются"
        :active="isTableLoading"
        height="200"
      />
    </div>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";
import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";
import Button from "@/components/controls2/Button";
import Loader from "@/components/loader";
import Input from "@/components/controls2/Input";
import Switcher from "@/components/controls2/Switcher";
import DataTablePersonalEmployee from "@/pages/personal-employee/additions/data-table-personal-employee";

Vue.use(VueCookies);

export default {
  name: "personal-employee-move-in-company",

  components: {
    "c-button": Button,
    "c-input": Input,
    "c-switcher": Switcher,
    "c-loader": Loader,
    "c-data-table-personal-employee": DataTablePersonalEmployee,
  },

  data() {
    return {
      isTableLoading: false,
      periodLocal: null,
      periodStart: this.$route.query.periodStart ? this.$route.query.periodStart : "",
      periodEnd: this.$route.query.periodEnd ? this.$route.query.periodEnd : "",
      isGroupedTable: this.$cookies.get("isGroupedMoveInCompanyTable") !== "false",
      tableRecordsLocal: [],
      tableRecordsLocalWithCategories: [],
      tableData: {
        type: "move-in-company",
        columns: [],
        records: [],
        enabledFields: [],
        actions: false,
        isGroupByCategory: this.$cookies.get("isGroupedMoveInCompanyTable") === "false" ? 0 : 1,
        sortedColumn: {
          sortBy: this.$route.query.sortBy ? this.$route.query.sortBy : "date_time",
          sortType: this.$route.query.sortType ? this.$route.query.sortType : "desc",
        },
        levels: 1,
        filteredColumns: [],
        activeFilteredColumns: [],
        globalFilters: [],
      },
    };
  },

  computed: {
    ...mapGetters("personalEmployee", ["getTableColumnsMoveInCompany"]),
  },

  watch: {
    isGroupedTable(value) {
      this.tableData.records = [];
      this.tableData.isGroupByCategory = value ? 1 : 0;
      Vue.$cookies.set("isGroupedMoveInCompanyTable", value);
      if (value) {
        this.tableData.records = [...this.tableRecordsLocalWithCategories];
      } else {
        this.tableData.records = [...this.tableRecordsLocal];
      }
    },
  },

  async created() {
    this.tableData.columns = this.getTableColumnsMoveInCompany.map((column) => {
      column.isSorted = column.id === this.tableData.sortedColumn.sortBy;
      return column;
    });
    this.getTableRecords();
  },

  mounted() {
    if (this.periodStart.length > 0 && this.periodEnd.length > 0) {
      this.$refs.moveInCompanyPeriod.period.start.input = this.periodStart;
      this.$refs.moveInCompanyPeriod.period.end.input = this.periodEnd;

      const period = `${this.periodStart}-${this.periodEnd}`;
      const today = moment().startOf("day").format("DD.MM.YYYY").toString();
      const yesterday = moment().startOf("day").subtract(1, "day").format("DD.MM.YYYY").toString();
      const firstDayCurrentWeek = moment().startOf("day").startOf("week").format("DD.MM.YYYY").toString();
      const lastDayCurrentWeek = moment().startOf("day").format("DD.MM.YYYY").toString();
      const firstDayLastWeek = moment()
        .startOf("day")
        .startOf("week")
        .subtract(1, "week")
        .format("DD.MM.YYYY")
        .toString();
      const lastDayLastWeek = moment().startOf("day").endOf("week").subtract(1, "week").format("DD.MM.YYYY").toString();
      const sevenDayAgo = moment().startOf("day").subtract(6, "day").format("DD.MM.YYYY").toString();
      const firstDayCurrentMonth = moment().startOf("day").startOf("month").format("DD.MM.YYYY").toString();
      const firstDayLastMonth = moment()
        .startOf("day")
        .subtract(1, "month")
        .startOf("month")
        .format("DD.MM.YYYY")
        .toString();
      const lastDayLastMonth = moment()
        .startOf("day")
        .subtract(1, "month")
        .endOf("month")
        .format("DD.MM.YYYY")
        .toString();

      if (today === this.periodStart && today === this.periodEnd) {
        this.$refs.moveInCompanyPeriod.dateValue = "Сегодня";
      } else if (yesterday === this.periodStart && yesterday === this.periodEnd) {
        this.$refs.moveInCompanyPeriod.dateValue = "Вчера";
      } else if (firstDayCurrentWeek === this.periodStart && lastDayCurrentWeek === this.periodEnd) {
        this.$refs.moveInCompanyPeriod.dateValue = "С начала недели";
      } else if (firstDayLastWeek === this.periodStart && lastDayLastWeek === this.periodEnd) {
        this.$refs.moveInCompanyPeriod.dateValue = "Прошлая неделя";
      } else if (today === this.periodEnd && sevenDayAgo === this.periodStart) {
        this.$refs.moveInCompanyPeriod.dateValue = "Последние 7 дней";
      } else if (firstDayCurrentMonth === this.periodStart && today === this.periodEnd) {
        this.$refs.moveInCompanyPeriod.dateValue = "Текущий месяц";
      } else if (firstDayLastMonth === this.periodStart && lastDayLastMonth === this.periodEnd) {
        this.$refs.moveInCompanyPeriod.dateValue = "Прошлый месяц";
      } else if (
        this.periodStart === moment().startOf("day").subtract(1, "month").format("DD.MM.YYYY").toString() &&
        today === this.periodEnd
      ) {
        this.$refs.moveInCompanyPeriod.dateValue = "Последний месяц";
      } else {
        this.$refs.moveInCompanyPeriod.dateValue = period;
      }
    }
  },

  methods: {
    getTableRecords() {
      const userId = this.$route.params.id;
      this.isTableLoading = true;
      this.$store
        .dispatch("personalEmployee/getDataWorkerMoveInCompany", {
          userId,
          sortBy: this.tableData.sortedColumn.sortBy,
          sortType: this.tableData.sortedColumn.sortType,
          periodStart: this.periodStart,
          periodEnd: this.periodEnd,
        })
        .then((res) => {
          this.tableRecordsLocal = [];
          this.tableRecordsLocalWithCategories = [];

          res.response.forEach((record) => {
            this.tableRecordsLocal.push({
              description: {
                value: record.dismiss
                  ? `<strong>Уволен</strong> по причине <strong>${record.dismiss.description}</strong>`
                  : record.description,
              },
              date: {
                value: record.date,
              },
              author: {
                value: record.author,
              },
              isShowRow: true,
            });

            if (record.post === null) {
              const c = this.tableRecordsLocalWithCategories.findIndex(
                (category) => category.categoryName === "Без должности",
              );
              if (c === -1) {
                this.tableRecordsLocalWithCategories.push({
                  categoryName: "Без должности",
                  records: [
                    {
                      description: {
                        value: record.dismiss
                          ? `<strong>Уволен</strong> по причине <strong>${record.dismiss.description}</strong>`
                          : record.description,
                      },
                      date: {
                        value: record.date,
                      },
                      author: {
                        value: record.author,
                      },
                      isShowRow: true,
                    },
                  ],
                });
              } else {
                this.tableRecordsLocalWithCategories[c].records.push({
                  description: {
                    value: record.dismiss
                      ? `<strong>Уволен</strong> по причине <strong>${record.dismiss.description}</strong>`
                      : record.description,
                  },
                  date: {
                    value: record.date,
                  },
                  author: {
                    value: record.author,
                  },
                  isShowRow: true,
                });
              }
            } /*else {
              const c = this.tableRecordsLocalWithCategories.findIndex(
                (category) => category.categoryName === record.post,
              );

              if (c === -1) {
                this.tableRecordsLocalWithCategories.push({
                  categoryName: record.post,
                  records: [
                    {
                      description: {
                        value: record.dismiss
                          ? `<strong>Уволен</strong> по причине <strong>${record.dismiss.description}</strong>`
                          : record.description,
                      },
                      date: {
                        value: record.date,
                      },
                      author: {
                        value: record.author,
                      },
                      isShowRow: true,
                    },
                  ],
                });
              } else {
                this.tableRecordsLocalWithCategories[c].records.push({
                  description: {
                    value: record.dismiss
                      ? `<strong>Уволен</strong> по причине <strong>${record.dismiss.description}</strong>`
                      : record.description,
                  },
                  date: {
                    value: record.date,
                  },
                  author: {
                    value: record.author,
                  },
                  isShowRow: true,
                });
              }
            }*/
          });

          if (this.isGroupedTable) {
            this.tableData.records = [...this.tableRecordsLocalWithCategories];
          } else {
            this.tableData.records = [...this.tableRecordsLocal];
          }

          const queryFilters = {
            ...(this.periodStart === "" ? null : { periodStart: this.periodStart }),
            ...(this.periodEnd === "" ? null : { periodEnd: this.periodEnd }),
          };

          this.$router
            .replace({
              name: "personal-employee-move-in-company",
              query: {
                sortBy: this.tableData.sortedColumn.sortBy,
                sortType: this.tableData.sortedColumn.sortType,
                ...queryFilters,
              },
            })
            .catch(() => {});

          setTimeout(() => {
            this.isTableLoading = false;
          }, 500);
        });
    },

    refreshTable(e) {
      this.tableData.sortedColumn.sortType = e.sortType;
      this.tableData.sortedColumn.sortBy = e.sortBy;
      this.getTableRecords();
    },

    applyFilters() {
      const periodStart = this.$refs.moveInCompanyPeriod.period.start.input;
      const periodEnd = this.$refs.moveInCompanyPeriod.period.end.input;

      if (periodStart !== this.periodStart || periodEnd !== this.periodEnd) {
        this.periodStart = periodStart;
        this.periodEnd = periodEnd;
        this.getTableRecords();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.move-in-company {
  &__filters {
    display: flex;
    margin-top: 35px;
    align-items: flex-end;
    max-width: 761px;

    @media screen and (max-width: 700px) {
      flex-direction: column;
    }

    &__period {
      ::v-deep & .c-input-container_period {
        transform: none;
        left: 0;
        @media screen and (max-width: 805px) {
          left: -30px;
        }
        @media screen and (max-width: 767px) {
          left: 0;
        }
      }

      @media screen and (max-width: 700px) {
        width: 100%;
      }
    }

    &__block {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 570px;
      width: 100%;
      margin-left: 33px;

      &__button {
        width: 130px;

        @media screen and (max-width: 700px) {
          margin-bottom: 23px;
          width: 100%;
        }
      }

      &__switcher {
        ::v-deep & .c-switcher {
          margin-bottom: 0;
        }
        @media screen and (max-width: 700px) {
          align-self: flex-start;
        }
      }

      @media screen and (max-width: 700px) {
        max-width: 100%;
        margin-left: 0;
        margin-top: 25px;
        flex-direction: column;
      }
    }
  }

  &__table {
    max-width: 763px;
    margin-top: 27px;

    @media screen and (max-width: 700px) {
      margin-top: 0px;
    }

    ::v-deep & .c-table .c-table__wrapper .c-table__container {
      table-layout: fixed;
    }

    ::v-deep & .c-table__cell-value {
      overflow-wrap: break-word;
    }

    &__loader {
      margin-top: 27px;

      @media screen and (max-width: 700px) {
        ::v-deep & .loader-overlay {
          width: calc(100% + 40px);
          left: -20px;
          border-right: none;
          border-left: none;
        }
      }
    }
  }
}
</style>
